import React, { Component } from 'react';
import DrawerSlideWrapper from './DrawerSlideWrapper';
import DrawerHeader from './DrawerHeader';
import { maskServiceDateNoDay } from '../../masks.js';
import MenuSelectionCard from './MenuSelectionCardNew';
import Formsy from 'formsy-react';
import FormsySimpleTextAreaNew from './FormsySimpleTextAreaNew';
import FormsySimpleInput from '../form/FormsySimpleInput';
import SplashMessageNew from './SplashMessageNew';

class MenuSelectionConfirm extends Component {
  state = {
    menu: {},
    menuSelections: [],
    specialInstructions: '',
    isUpdated: false,
  };
  render() {
    const {
      handleClose,
      menuStartTime,
      isOpen,
      handleBackToEdit,
      handleChange,
      handleSubmit,
      service,
      client,
      favoritedDishes,
      favoriteDish,
      unfavoriteDish,
      location = {
        pathname: '',
      },
    } = this.props;
    const { menuSelections, specialInstructions } = this.state;

    const isNewClientOnboarding = location.pathname.includes('new-client');

    const formClasses = isNewClientOnboarding
      ? 'menu-confirmation__instructions-form--onboarding'
      : 'menu-confirmation__instructions-form';

    return (
      // make this a form
      <DrawerSlideWrapper isOpen={isOpen} isLeft={true}>
        <DrawerHeader
          title="Menu Selection"
          handleClose={handleClose}
          subtitle={`Weekly Service ${
            maskServiceDateNoDay(menuStartTime) || ''
          }`}
        />
        <SplashMessageNew />
        <div className="menu-confirmation">
          <div className="menu-confirmation__edit-section">
            <div className="menu-confirmation__sub-header-wrap">
              <h3 className="menu-confirmation__subheader">Dish Selections</h3>
            </div>
            <button
              className="new-btn new-btn--hollow-blue new-btn--full-width menu-confirmation__edit-btn"
              onClick={handleBackToEdit}
            >
              Edit
            </button>
          </div>
          <div className="menu-confirmation__dish-list">
            <ul className="menu-selection-new__cards">
              {menuSelections &&
                menuSelections.map((selection, ix) => {
                  return (
                    <li key={`${selection.dish_id}-confirm-${ix}`}>
                      <MenuSelectionCard
                        displayOnly={true}
                        dish={selection.dish}
                        menuSelection={selection}
                        className="menu-selection-card-new "
                        service={service}
                        client={client}
                        favoritedDishes={favoritedDishes}
                        favoriteDish={favoriteDish}
                        unfavoriteDish={unfavoriteDish}
                      />
                    </li>
                  );
                })}
            </ul>
          </div>
          {!isNewClientOnboarding && (
            <div className="menu-confirmation__service-instructions-section">
              <div className="menu-confirmation__subheader-wrap">
                <h3 className="menu-confirmation__subheader">
                  Service Instructions
                </h3>
              </div>
              <p className="menu-confirmation__service-instructions-prompt">
                Enter any other preferences about your menu, groceries, chef, or
                service here.
              </p>
            </div>
          )}
          <Formsy
            id="submit-dishes-form"
            className={formClasses}
            onValidSubmit={handleSubmit}
          >
            <FormsySimpleInput
              type="hidden"
              name="total"
              value={menuSelections.length}
              validations="isGreaterThan:0"
            />

            {!location.pathname.includes('new-client') && (
              <FormsySimpleTextAreaNew
                title="Service Instructions"
                type="text"
                name="special_instructions"
                placeholder=""
                value={specialInstructions}
                onChange={handleChange}
              />
            )}
          </Formsy>
        </div>
      </DrawerSlideWrapper>
    );
  }

  resetState = (time = 1000) => {
    // reset after delay
    setTimeout(
      function () {
        this.setState({
          isUpdated: false,
          menu: {},
          menuSelections: [],
          specialInstructions: '',
        });
      }.bind(this),
      time
    );
  };

  componentDidUpdate(prevProps) {
    const {
      menu,
      menuSelections,
      specialInstructions,
      hasUpdated,
      handleClose,
    } = this.props;

    if (
      prevProps.menu !== menu ||
      prevProps.menuSelections !== menuSelections
    ) {
      this.setState({
        menu,
        menuSelections: menuSelections.filter(
          (selection) => selection.quantity > 0
        ),
      });
    }

    if (specialInstructions !== prevProps.specialInstructions) {
      this.setState({ specialInstructions });
    }

    if (hasUpdated !== prevProps.hasUpdated) {
      if (!hasUpdated) {
        // close screen
        handleClose();
        // reset state after drawer has closed
        this.resetState();
      }
    }
  }
}

export default MenuSelectionConfirm;



// WEBPACK FOOTER //
// ./src/components/new/MenuSelectionConfirm.js